<ng-container *ngIf="layoutMode === 'navbar'">
  <collabora></collabora>
</ng-container>

<ng-container *ngIf="layoutMode === 'sidebar'">
  <collabora-sidebar></collabora-sidebar>
</ng-container>
